import "../scss/init.scss";

import Vue from 'vue';
import registerVueDirectives from "./directives";
import Vuelidate from 'vuelidate';
import VueLazyload from 'vue-lazyload';
import VueSmoothScroll from 'vue2-smooth-scroll';
import VueScrollTo from 'vue-scrollto';
import documentReady from './assets/js/documentReady';
import paymentServicePopup from './modules/paymentServicePopup';

Vue.use(Vuelidate);
Vue.use(VueLazyload, {
    lazyComponent: true,
});

Vue.config.productionTip = false;

registerVueDirectives();

Vue.use(VueSmoothScroll, {
    offset: (document.getElementById('header')) ? -(document.getElementById('header').offsetHeight) : 0,
});

Vue.use(VueScrollTo, {
    offset: (document.getElementById('header')) ? -(document.getElementById('header').offsetHeight) : 0,
});

Vue.filter("formatNumber", function (value) {
    value = Number(value).toFixed(0);
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
});

// Auto include vue components
const files = require.context('./components', true, /\.vue$/i);
files.keys().map(key =>
    Vue.component(
        key
            .split('/')
            .pop()
            .split('.')[0],
        files(key).default,
    ),
);

documentReady(() => {
    new Vue({
        data: {
            popup: {
                call: false,
                region: false,
            },
        },
        mounted() {
            paymentServicePopup.init();
        },
    }).$mount('#app');
});

// Багфикс в рамках правок для IE DMDSUPP-8025
// Форма выведена из компонента ServicesList
// let initForm = setInterval(function () {
//     if (document.getElementById('new-payment-form') || !document.getElementById('app')) {
//         console.log('if new-payment-form')
//         let newPaymentForm = {
//             el: '#new-payment-form',
//             components: {
//                 newPaymentForm: () => import(/* webpackChunkName: "newPaymentForm" */ './components/new-payment-form/index')
//             }
//         };

//         new Vue(newPaymentForm);
//         clearInterval(initForm)
//     }

// }, 500)

let initFormInv = setInterval(function () {
    if (document.getElementById('invoice-pay') || !document.getElementById('app')) {
        let invoicePay = {
            el: '#invoice-pay',
            components: {
                invoicePay: () => import(/* webpackChunkName: "invoicePay" */ './components/invoicePay/index')
            }
        };

        new Vue(invoicePay);
        clearInterval(initFormInv)
    }

}, 500)